module.exports = __webpack_public_path__ + "img/mt.976a9444.svg";